export function objectStringToBoolean(values, toBooleanValues) {
  return Object.fromEntries(
    Object.entries(values).map(([key, value]) => {
      if (toBooleanValues.includes(key)) {
        if (value === 'yes') {
          return [key, true];
        }
        return [key, false];
      }
      return [key, value];
    })
  );
}
